var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 23
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 11.5c3.156 0 5.714-2.574 5.714-5.75S13.156 0 10 0 4.286 2.574 4.286 5.75 6.844 11.5 10 11.5m4 1.438h-.746a7.74 7.74 0 0 1-6.508-.001H6c-3.313 0-6 2.705-6 6.038v1.869C0 22.034.96 23 2.143 23h15.714A2.15 2.15 0 0 0 20 20.844v-1.869c0-3.333-2.688-6.038-6-6.038z"
})));
export { SvgIconUser as ReactComponent };
export default __webpack_public_path__ + "../icons/b12996a69c219cbe07f08e084a7b6ed5.svg";